import axios from 'axios';
import { SERVER_URL } from "../const";
import Qs from 'qs';


export const getFtaDataService = async (iec_no, filters) => {
  const token = localStorage.getItem('token');
  try {
    let params = {
      iec_no,
      ...filters,
      br_code: filters.br_code
    };
    // Make a GET request to fetch Fta data based on the IEC number
    const response = await axios.get(`${SERVER_URL}/get-fta-details`, {
      params,
      paramsSerializer: params => {
        return Qs.stringify(params, { arrayFormat: 'repeat' })
      },
      headers: { 'Authorization': `Bearer ${token}` }
    });
    console.log(response.data)
    return response.data; // Return the data from the response
  } catch (error) {
    throw new Error('Error fetching Fta data:', error);
  }
};


export const getFtaOppDataService = async (iec_no, filters) => {
  const token = localStorage.getItem('token');
  try {
    let params = {
      iec_no,
      ...filters,
      br_code: filters.br_code
    };
    // Make a GET request to fetch Fta data based on the IEC number
    const response = await axios.get(`${SERVER_URL}/reports/fta-opp-details`, {
      params,
      paramsSerializer: params => {
        return Qs.stringify(params, { arrayFormat: 'repeat' })
      },
      headers: { 'Authorization': `Bearer ${token}` }
    });
    console.log(response.data)
    return response.data; // Return the data from the response
  } catch (error) {
    throw new Error('Error fetching Fta data:', error);
  }
};


export const getFtaOppDashboardSummaryService = async (filters) => {
  const token = localStorage.getItem('token');
  try {
    const response = await axios.post(
      `${SERVER_URL}/get-dashboard-report-summary`,
      {
        report_type: ['FTA-Opportunity'],
        filters: {
          from_date: filters.from_date || null,
          to_date: filters.to_date || null,
        },
      },
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error('Error fetching FTA Opportunity dashboard summary: ' + error);
  }
};


export const getFtaApplicabilityDataService = async (iec_no, filters) => {
  const token = localStorage.getItem('token');
  try {
    let params = {
      iec_no,
      ...filters,
      br_code: filters.br_code
    };
    // Make a GET request to fetch Fta data based on the IEC number
    const response = await axios.get(`${SERVER_URL}/reports/fta-applicability-details`, {
      params,
      paramsSerializer: params => {
        return Qs.stringify(params, { arrayFormat: 'repeat' })
      },
      headers: { 'Authorization': `Bearer ${token}` }
    });
    console.log(response.data)
    return response.data; // Return the data from the response
  } catch (error) {
    throw new Error('Error fetching Fta data:', error);
  }
};


export const getFtaOppReportSummaryService = async (iec_no, filters) => {
  const token = localStorage.getItem('token');
  try {
    const params = {
      iec_no,
      from_date: filters.from_date || null,
      to_date: filters.to_date || null,
      br_code: filters.br_code || null,
      coo_cos: filters.coo_cos || null,
    };
    const response = await axios.get(`${SERVER_URL}/reports/fta-opp-summary`, {
      params,
      paramsSerializer: params => {
        return Qs.stringify(params, { arrayFormat: 'repeat' })
      },
      headers: { 'Authorization': `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    throw new Error('Error fetching FTA Opportunity summary: ' + error);
  }
};


export const getFtaApplicabilityDashboardSummaryService = async (iec_no, filters) => {
  const token = localStorage.getItem('token');
  try {
    const response = await axios.post(
      `${SERVER_URL}/get-dashboard-report-summary`,
      {
        report_type: ['FTA-Applicability'],
        iec_no: iec_no,
        filters: {
          from_date: filters.from_date || null,
          to_date: filters.to_date || null,
          br_code: filters.br_code || null,
          bill_no: filters.bill_no || null,
        },
      },
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error('Error fetching FTA Applicability dashboard summary: ' + error);
  }
};
